import cx from 'classnames'
import styles from './AgreementRenderer.module.css'
import { Skeleton } from '@/components/Skeleton'

export interface AgreementRendererProps {
  markup: string
  isSkeleton?: boolean
  withBackground?: boolean
  testId?: string
}

/**
 * The AgreementRenderer
 */
export function AgreementRenderer({
  markup,
  isSkeleton,
  withBackground = false,
  testId,
}: AgreementRendererProps) {
  return (
    <div className={cx(withBackground && styles.root)} data-test={testId}>
      {isSkeleton ? (
        <div className={styles.prose}>
          <p>
            <b>
              <Skeleton width="90%" />
            </b>
          </p>

          <p>
            <Skeleton width="99%" />
            <Skeleton width="97%" />
            <Skeleton width="100%" />
            <Skeleton width="100%" />
            <Skeleton width="40%" />
          </p>
          <p>
            <Skeleton width="90%" />
            <Skeleton width="97%" />
            <Skeleton width="94%" />
            <Skeleton width="97%" />
            <Skeleton width="44%" />
            <Skeleton width="90%" />
            <Skeleton width="84%" />
            <Skeleton width="90%" />
            <Skeleton width="97%" />
          </p>
          <p>
            <Skeleton width="97%" />
            <Skeleton width="90%" />
            <Skeleton width="99%" />
            <Skeleton width="94%" />
          </p>
          <p>
            <Skeleton width="100%" />
            <Skeleton width="97%" />
            <Skeleton width="80%" />
          </p>
        </div>
      ) : (
        <div
          className={styles.prose}
          dangerouslySetInnerHTML={{ __html: markup }}
        />
      )}
    </div>
  )
}
